module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "budget-followup-ebitda"
  }, [(_vm.data) ? _c('div', [(_vm.accountsModal) ? _c('div', {
    staticClass: "accounts-modal"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('div', {
    staticClass: "inner__title"
  }, [_vm._v("\n                    Underkonti for \"" + _vm._s(_vm.accountsModal.name) + "\"\n                ")]), _vm._v(" "), _c('table', {
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [_vm._l((_vm.accountsModal.accounts), function(account, index) {
    return _c('tr', {
      key: 'account_' + index
    }, [_c('td', {
      attrs: {
        "align": "left"
      }
    }, [_vm._v(_vm._s(account.account_number))]), _vm._v(" "), _c('td', {
      attrs: {
        "align": "left"
      }
    }, [_vm._v(_vm._s(account.name))]), _vm._v(" "), _c('td', {
      attrs: {
        "align": "right"
      }
    }, [_vm._v(_vm._s(_vm._f("currency")(account.real_expenses)))]), _vm._v(" "), _c('td', {
      attrs: {
        "align": "right"
      }
    }, [(account.expenses_budget_to_now !== 0) ? _c('span', [_vm._v("\n                                    " + _vm._s(_vm._f("currency")(account.expenses_budget_to_now)) + "\n                                ")]) : _c('span', [_vm._v("-")])]), _vm._v(" "), _c('td', {
      attrs: {
        "align": "right"
      }
    }, [(account.expenses_budget_to_now !== 0) ? _c('span', [_c('span', {
      class: {
        'color-good': (account.real_expenses - account.expenses_budget_to_now) > 0, 'color-bad': (account.real_expenses - account.expenses_budget_to_now) < 0
      }
    }, [((account.real_expenses - account.expenses_budget_to_now) > 0) ? _c('span', [_vm._v("+")]) : _vm._e(), _vm._v(_vm._s(_vm._f("currency")(account.real_expenses - account.expenses_budget_to_now)) + "\n                                        ")])]) : _c('span', [_vm._v("-")])])])
  }), _vm._v(" "), _c('tr', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Total")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "align": "right"
    }
  }, [_vm._v(_vm._s(_vm._f("currency")(_vm.accountsModal.real_expenses)))]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "right"
    }
  }, [(_vm.accountsModal.expenses_budget_to_now !== 0) ? _c('span', [_vm._v("\n                                    " + _vm._s(_vm._f("currency")(_vm.accountsModal.expenses_budget_to_now)) + "\n                                ")]) : _c('span', [_vm._v("-")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "right"
    }
  }, [(_vm.accountsModal.expenses_budget_to_now !== 0) ? _c('span', [_c('span', {
    class: {
      'color-good': (_vm.accountsModal.real_expenses - _vm.accountsModal.expenses_budget_to_now) > 0, 'color-bad': (_vm.accountsModal.real_expenses - _vm.accountsModal.expenses_budget_to_now) < 0
    }
  }, [((_vm.accountsModal.real_expenses - _vm.accountsModal.expenses_budget_to_now) > 0) ? _c('span', [_vm._v("+")]) : _vm._e(), _vm._v(_vm._s(_vm._f("currency")(_vm.accountsModal.real_expenses - _vm.accountsModal.expenses_budget_to_now)) + "\n                                        ")])]) : _c('span', [_vm._v("-")])])])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "close-wrapper"
  }, [_c('button', {
    staticClass: "budget-btn",
    on: {
      "click": function($event) {
        _vm.accountsModal = null
      }
    }
  }, [_vm._v("\n                        Luk\n                    ")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "placeholder"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_c('d-tooltip', {
    attrs: {
      "identifier": "budgetfollowup.ebitda",
      "placement": "left"
    }
  }), _vm._v("\n                EBITDA\n            ")], 1), _vm._v(" "), _c('div', {
    staticClass: "placeholder padding"
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "center"
    }
  }, [_c('div', {
    staticClass: "employee-switcher",
    staticStyle: {
      "margin-bottom": "30px"
    }
  }, [_c('div', {
    staticClass: "employee-switcher-option lg",
    class: {
      'selected': _vm.period === 'budgetyear'
    },
    on: {
      "click": function($event) {
        _vm.period = 'budgetyear'
      }
    }
  }, [_vm._v("\n                            Budgetåret til dato\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "employee-switcher-option lg",
    class: {
      'selected': _vm.period === 'month'
    },
    on: {
      "click": function($event) {
        _vm.period = 'month'
      }
    }
  }, [_vm._v("\n                            Denne måned\n                        ")])])]), _vm._v(" "), _c('table', {
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.data.account_categories), function(accountCategory, index) {
    return _c('tr', {
      key: 'accountCategory_' + index,
      class: {
        'bold': ['Dækningsbidrag 1', 'Dækningsbidrag 2', 'EBITDA'].includes(accountCategory.name)
      }
    }, [_c('td', {
      attrs: {
        "align": "left"
      }
    }, [(accountCategory.accounts.length > 0) ? _c('i', {
      staticClass: "fas fa-list fa-fw",
      on: {
        "click": function($event) {
          _vm.accountsModal = accountCategory
        }
      }
    }) : _c('i', {
      staticClass: "fas fa-list fa-fw",
      staticStyle: {
        "opacity": "0"
      }
    }), _vm._v("\n                                 " + _vm._s(accountCategory.name) + "\n                            ")]), _vm._v(" "), _c('td', {
      attrs: {
        "align": "right"
      }
    }, [_vm._v(_vm._s(_vm._f("currency")(accountCategory.real_expenses)))]), _vm._v(" "), _c('td', {
      attrs: {
        "align": "right"
      }
    }, [(accountCategory.expenses_budget_to_now !== 0) ? _c('span', [_vm._v("\n                                    " + _vm._s(_vm._f("currency")(accountCategory.expenses_budget_to_now)) + "\n                                ")]) : _c('span', [_vm._v("-")])]), _vm._v(" "), _c('td', {
      attrs: {
        "align": "right"
      }
    }, [(accountCategory.expenses_budget_to_now !== 0) ? _c('span', [_c('span', {
      class: {
        'color-good': (accountCategory.real_expenses - accountCategory.expenses_budget_to_now) > 0, 'color-bad': (accountCategory.real_expenses - accountCategory.expenses_budget_to_now) < 0
      }
    }, [((accountCategory.real_expenses - accountCategory.expenses_budget_to_now) > 0) ? _c('span', [_vm._v("+")]) : _vm._e(), _vm._v(_vm._s(_vm._f("currency")(accountCategory.real_expenses - accountCategory.expenses_budget_to_now)) + "\n                                        ")])]) : _c('span', [_vm._v("-")])])])
  }), 0)])])])]) : _c('div', [_c('box-loading')], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Konto")]), _vm._v(" "), _c('th', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Navn")]), _vm._v(" "), _c('th', {
    attrs: {
      "align": "right",
      "width": "20%"
    }
  }, [_vm._v("Realiseret")]), _vm._v(" "), _c('th', {
    attrs: {
      "align": "right",
      "width": "20%"
    }
  }, [_vm._v("Budget")]), _vm._v(" "), _c('th', {
    attrs: {
      "align": "right",
      "width": "20%"
    }
  }, [_vm._v("Difference")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Konto")]), _vm._v(" "), _c('th', {
    attrs: {
      "align": "right",
      "width": "20%"
    }
  }, [_vm._v("Realiseret")]), _vm._v(" "), _c('th', {
    attrs: {
      "align": "right",
      "width": "20%"
    }
  }, [_vm._v("Budget")]), _vm._v(" "), _c('th', {
    attrs: {
      "align": "right",
      "width": "20%"
    }
  }, [_vm._v("Difference")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-794c9c50"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/economy/learning/components/budgetEbitda.vue
// module id = 905
// module chunks = 0